/** Creation default only. Publication always uses the bound product environment. */
export type PaddleEnvironmentChoice = 'sandbox' | 'production';

export function defaultPaddleEnvironment(input: {
  sandboxConnected: boolean;
  productionConnected: boolean;
  activeEnvironment?: PaddleEnvironmentChoice;
}): PaddleEnvironmentChoice {
  if (input.sandboxConnected && !input.productionConnected) return 'sandbox';
  if (input.productionConnected && !input.sandboxConnected) return 'production';
  return input.activeEnvironment ?? 'sandbox';
}
